import { loadScriptPromise } from "../utils/script";
import React from "react";
import { ERROR_SYSTEM } from "../../main/route";
import { Redirect } from "react-router-dom";
import { LoadStatusWithResponseDetail } from "../utils/async-status";

const promiseBySrc: Record<string, Promise<void>> = {};

export default class ScriptProvider extends React.Component<{
  src: string;
  onLoad: () => Promise<void>;
}> {
  state = {
    status: LoadStatusWithResponseDetail.PENDING,
  };

  componentDidMount() {
    const { src, onLoad } = this.props;
    if (!promiseBySrc[src]) {
      promiseBySrc[src] = loadScriptPromise(this.props.src).then(onLoad);
    }

    promiseBySrc[src]
      .then(() => {
        this.setState({ status: LoadStatusWithResponseDetail.OK });
      })
      .catch(() => {
        this.setState({ status: LoadStatusWithResponseDetail.ERROR });
      });
  }

  render() {
    if (this.state.status === LoadStatusWithResponseDetail.PENDING) {
      return null;
    }
    if (this.state.status === LoadStatusWithResponseDetail.ERROR) {
      return <Redirect to={ERROR_SYSTEM} />;
    }

    return this.props.children;
  }
}
